import { useLoaderData } from 'react-router';

import type { loader } from '~/routes/_app.project.$urlSegment._index';
import {
    DetailTestimonialBand,
    hasRenderableTestimonial,
} from '~/ui-rocco/pages/detail-shared';
import { SectionSpacer } from '~/ui-rocco/pages/home-page/components/SectionSpacer';

/**
 * The product page's pull quote, on the project: what has been said about
 * the practice behind it, under the hire cards, drawn by the shared band on
 * the page's dark ground.
 */
export const ProjectTestimonialSection = () => {
    const { project } = useLoaderData<typeof loader>();
    const testimonials = project.Professional?.Testimonials ?? [];

    // The gap above belongs to this band, so it goes when the band goes:
    // left in the page it outlived the section and stacked with its
    // neighbours into one empty run.
    if (!hasRenderableTestimonial(testimonials)) return null;

    return (
        <>
            <SectionSpacer height={120} mobileHeight={48} unit="rem" />
            <DetailTestimonialBand
                theme="dark"
                label="Professional Reviews"
                testimonials={testimonials}
            />
        </>
    );
};
